














import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class CountWidget extends Vue {
	@Prop({ required: true })
	count!: number;
	@Prop({ required: true })
	itemName!: string;
	@Prop({ required: false })
	icon!: string;
	@Prop({ required: false, default: "" })
	redirectTo!: string;
	@Prop({ required: true })
	loading!: boolean;
	@Prop({ required: false, default: "Add" })
	addDataButtonText!: string;
	@Prop({ required: false, default: false })
	showAddDataButton!: boolean;
}
